import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import './App.css';
import MenuAdmin from './pages/MenuAdmin';
import MenuGuest from './pages/MenuGuest';
import LoginPage from './pages/LoginPage';

class App extends React.Component {
  public render() {
    return (
      <div>
        <Router>
          <Switch>
            <div>
              <Route exact={true} path="/" render={(props) => <MenuGuest {...props} />} />
              <Route exact={true} path="/:action" render={(props) => <MenuGuest {...props} />} />
              <Route exact={true} path="/login/" render={(props) => <LoginPage {...props} />} />
              <Route exact={true} path="/admin/" render={(props) => <MenuAdmin {...props} />} />
              <Route exact={true} path="/admin/:action" render={(props) => <MenuAdmin {...props} />} />
            </div>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx